import {
  GET_PUBLIC_CHEATSHEETS,
  GET_PRIVATE_CHEATSHEETS,
  TOGGLE_CHEATSHEET,
  GET_CHEATSHEETS_BY_TAG,
  GET_CHEATSHEETS_BY_CATEGORY,
  ADMIN_DETAILS_CHEATSHEET,
  PUBLIC_DETAILS_CHEATSHEET,
  GET_CHEATSHEET_BY_LINK,
  ADD_LIKE,
  TOGGLE_LIKE_ADDING,
  CHEATSHEET_LOADING
} from "../actions/types";

const initialState = {
  all_public_cheatsheet: [],
  admin_cheatsheet_details: {},
  public_cheatsheet_details: {},
  all_private_cheatsheets: {},
  cheatsheet_by_tag: [],
  cheatsheet_by_category: [],
  cheatsheet_by_link:[],
  cheatsheet_loading: false,
  addLikeLoading: false,
  loading: false,
};

export default function articleReducer(state = initialState, action) {
  switch (action.type) {
    case GET_CHEATSHEETS_BY_CATEGORY:
      return {
        ...state,
        cheatsheet_by_category: [...action.payload],
      };
    case GET_CHEATSHEETS_BY_TAG:
      return {
        ...state,
        cheatsheet_by_tag: [...action.payload],
      };

    case GET_CHEATSHEET_BY_LINK:
      return {
        ...state,
        cheatsheet_by_link:[...action.payload]
      };

    case PUBLIC_DETAILS_CHEATSHEET:
      return {
        ...state,
        public_cheatsheet_details: action.payload,
        loading: false,
      };

    case CHEATSHEET_LOADING:
      return {
        ...state,
        loading: true,
      };

    case ADD_LIKE:
      return {
        ...state,
        cheatsheet_by_link: state.cheatsheet_by_link.map((c) =>
          c._id === action.payload._id ? action.payload : c
        ),
      };
    case TOGGLE_LIKE_ADDING:
      return {
        ...state,
        addLikeLoading: !state.addLikeLoading,
      };

    case ADMIN_DETAILS_CHEATSHEET:
      return {
        ...state,
        admin_cheatsheet_details: action.payload,
      };
    case GET_PUBLIC_CHEATSHEETS:
      return {
        ...state,
        all_public_cheatsheet: action.payload,
        loading:false
      };
    case   GET_PRIVATE_CHEATSHEETS:
      return {
        ...state,
        all_private_cheatsheets: action.payload,
      };
    case TOGGLE_CHEATSHEET:
      return {
        ...state,
        cheatsheet_loading: !state.cheatsheet_loading,
      };
    default:
      return state;
  }
}
